import { isMetronomePractice, isSheetPractice, MetronomeEvaluator, SheetEvaluator } from '@ezchops/game/lib/practice';
import React, { useContext, useMemo } from 'react';
import { useMetronomeBot } from '../components/practice/bots/metronomeBot';
import { useAutoStopPractice } from '../components/practice/useAutoStopPractice';
import { useClockState, useTrackClock } from '../hooks';
import { ClockTickProvider } from './ClockTickContext';
export function usePracticeContext() {
    const context = useContext(PracticeContext);
    if (context == null) {
        throw new Error('No practice context');
    }
    return context;
}
export const PracticeContext = React.createContext(null);
/**
 * @deprecated
 * @param props
 * @constructor
 */
export function PracticeContextProvider(props) {
    if (useContext(PracticeContext) != null) {
        throw new Error('PracticeContextProvider can only be used once');
    }
    const { children, metronomeSheet, track, practice, mode, pads, autoStart } = props;
    const evaluator = useMemo(() => {
        if (isSheetPractice(practice)) {
            return new SheetEvaluator(practice);
        }
        else if (isMetronomePractice(practice)) {
            return new MetronomeEvaluator(practice);
        }
        else {
            throw new Error('Unknown practice type');
        }
    }, [practice]);
    const clock = useTrackClock(track, practice, autoStart);
    const clockState = useClockState(clock, evaluator.timing);
    const context = {
        clock, clockState, metronomeSheet,
        evaluator, mode, pads, practice
    };
    return React.createElement(PracticeContext.Provider, { value: context },
        React.createElement(ClockTickProvider, { clock: clock, clockState: clockState, timing: evaluator.timing },
            React.createElement(MetronomeAndAutoStop, null, children)));
}
export function MetronomeAndAutoStop({ children }) {
    useAutoStopPractice();
    useMetronomeBot();
    return React.createElement(React.Fragment, null, children);
}
//# sourceMappingURL=PracticeContext.js.map